import LessonElement from './LessonElement';

export default LessonElement;
